<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.ksny"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.jsny"></el-date-picker>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="商户名">
        <el-input v-model="formInline.shm"></el-input>
      </el-form-item>
      <el-form-item label="品牌名">
        <el-input v-model="formInline.ppm"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <el-button type="warning" @click="save" class="chaxun" v-if="ht==1 || md==1">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-table :data="tableData" :height="conheight" style="width: 100% !important;border-top: 1px solid #000 !important;border-left: 1px solid #000 !important;"> -->
    <el-table :data="tableData" :height="conheight" style="width: 100% !important;" border>
      <el-table-column label="序号" width="50"><template slot-scope="scope">{{scope.$index+1}}</template></el-table-column>
      <el-table-column prop="F_MD" label="门店"></el-table-column>
      <el-table-column prop="F_GYSMC" label="商户名"></el-table-column>
      <el-table-column prop="F_PPMC" label="品牌">
          <template slot-scope="scope">
            <span style="text-decoration: underline;text-decoration-color: blue;color: blue;" @click="open(scope.row)">{{scope.row.F_PPMC}}</span>
          </template>
      </el-table-column>
      <el-table-column prop="F_HTH" label="合同号"></el-table-column>
      <el-table-column prop="F_LXR" label="品牌联系人"></el-table-column>
      <el-table-column prop="F_LXSJH" label="品牌联系人手机号"></el-table-column>
      <el-table-column prop="F_DXSFFSCG" label="品牌短信是否通知成功"></el-table-column>
      <el-table-column prop="F_ZSRY" label="招商人员"></el-table-column>
      <el-table-column prop="F_ZSRYSJH" label="招商人员手机号"></el-table-column>
      <el-table-column prop="F_ZSRYTZSFCG" label="海雅短信是否通知成功"></el-table-column>
      <el-table-column prop="F_CJSJ" label="创建时间">
        <template slot-scope="scope">
          {{timestampToYYYYMMDD(scope.row.F_CJSJ)}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "ht",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      // {value: '海雅百货东莞南城店',label: '海雅百货东莞南城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        ksny:'',
        jsny:new Date(),
        hth:'',
        shm:'',
        ppm:''
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
      ht:0,
      md:0,
    };
  },
  methods: {
    save(){
      window.open("/fvue/statement/template/form/dyzl/add/true?startFlow=false&isNewPage=true","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    open(row){
      if(this.ht==1 || this.md==1){
        window.open("/fvue/statement/template/form/dyzl/edit/true?id="+row.ID_+"&startFlow=false&isNewPage=true","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }else{
        window.open("/fvue/statement/template/form/dyzl/get/true?id="+row.ID_+"&startFlow=false&isNewPage=true","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }
    },
    timestampToYYYYMMDD(timestamp) {
      const date = new Date(timestamp); // 将时间戳转换为Date对象
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份需要加1，且保证两位数显示
      const day = ("0" + date.getDate()).slice(-2); // 保证日期显示两位数
      return year +"-"+ month +"-"+ day;
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+month;
      return formattedDate;
    },
    onSubmit() {
      this.tableData = [];
      let sql = "select * from w_su_print where f_lxsjh='"+this.user.account.replaceAll("SZHY","")+"'";
      if(this.ht==1){
        sql = "select * from w_su_print where 1=1";
      }
      if(this.md==1){
        sql = "select * from w_su_print where 1=1 and f_mdid in(select companyid from V_HY_RYXX where account='"+this.user.account+"')";
      }
      if(this.formInline.md.length>0){
        sql += " and instr(f_md,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.ksny!=null && this.formInline.ksny!='' && this.formInline.jsny!=null && this.formInline.jsny!=''){
        sql += " and to_char(f_cjsj,'yyyymm') BETWEEN '"+this.getDate(this.formInline.ksny)+"' and '"+this.getDate(this.formInline.jsny)+"'";
      }

      if(this.formInline.hth.length>0){
        sql += " and instr(f_hth,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.shm.length>0){
        sql += " and instr(f_gysmc,'"+this.formInline.shm+"',1,1)>0";
      }
      if(this.formInline.ppm.length>0){
        sql += " and instr(f_ppmc,'"+this.formInline.ppm+"',1,1)>0";
      }
      sql += "order by f_cjsj desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    getList(){
      let sql = "select * from w_su_print where to_char(f_cjsj,'yyyymm') BETWEEN to_char(add_months(sysdate,-12),'yyyymm') and to_char(sysdate,'yyyymm') and f_lxsjh='"+this.user.account.replaceAll("SZHY","")+"' order by f_cjsj desc";
      if(this.ht==1){
        sql = "select * from w_su_print where to_char(f_cjsj,'yyyymm') BETWEEN to_char(add_months(sysdate,-12),'yyyymm') and to_char(sysdate,'yyyymm') order by f_cjsj desc";
      }
      if(this.md==1){
        sql = "select * from w_su_print where f_mdid in(select companyid from V_HY_RYXX where account='"+this.user.account+"') and to_char(f_cjsj,'yyyymm') BETWEEN to_char(add_months(sysdate,-12),'yyyymm') and to_char(sysdate,'yyyymm') order by f_cjsj desc";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    print(row,type){//打印付款请款单
      if(type=='fkqkd'){
        window.open("/fvue/print_fkqkd?JLBH="+row.JLBH+"&HSFS="+row.HSFS,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }
      if(type=='kpqrd'){
        window.open("/fvue/print_kpqrd?JLBH="+row.JLBH+"&HSFS="+row.HSFS,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }
    }
  },
  mounted(){
    const _this = this;
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 12); // 将月份减去1
    _this.formInline.ksny=currentDate;

    
    let User = JSON.parse(window.sessionStorage.currentUser);
    let sql = "select * from UC_USER_ROLE where is_dele_=0 and user_id_='"+User.userId+"'";
    _this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
      if(resp.data.result.length>0){
        for(let i=0;i<resp.data.result.length;i++){
          if(resp.data.result[i].ROLE_ID_=='1821074083270496256'){//合同部角色
            _this.ht=1;
            _this.activeName='ht';
          }
          if(resp.data.result[i].ROLE_ID_=='1902914013096972288'){//门店下发合同
            _this.md=1;
          }
        }
      }
      _this.getList();
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
</style>